// ════════════════════════════════════════════════════════════════════════
// VASSTR BRAND SYSTEM — single source of truth for the marketing + auth UI.
// Landing page, navbar, login and register all import from here so the look
// stays consistent ("big production SaaS"): same palette, fonts, and logo.
// ════════════════════════════════════════════════════════════════════════
import vasstrLogo from '../media/vasstrOrangeLogo_small.png';

// Palette
export const ORANGE = '#d45614';
export const ORANGE_DARK = '#a8430e';
export const ORANGE_LIGHT = '#e67d47';
export const INK = '#1c1b1a';
export const MUTED = '#5c5852';
export const PAPER = '#faf7f2';
export const CREAM = '#fdf3e9';

// Type
export const DISPLAY = "'Bricolage Grotesque', 'Plus Jakarta Sans', system-ui, sans-serif";
export const BODY = "'Plus Jakarta Sans', system-ui, sans-serif";

// Logo asset (burnt-orange "VASSTR" serif wordmark, transparent bg, ~4.6:1)
export { vasstrLogo };

const BRAND = { ORANGE, ORANGE_DARK, ORANGE_LIGHT, INK, MUTED, PAPER, CREAM, DISPLAY, BODY, vasstrLogo };
export default BRAND;
